<template>
<div>
    <loader-compartido></loader-compartido>
<div class="cont2">
        <!-- <h1>Dashboard</h1> -->
        
        <!-- <v-row>
            <v-col>
                <h1>Parámetros</h1>
                <v-divider></v-divider>
            </v-col>
        </v-row> -->

        <!-- <v-row class="pa-1">
            <v-col>
                <v-select
                :items="puntos_medicion"
                item-text="nombre_punto"
                item-value="id"
                v-model="punto"
                label="Seleccione Punto de Medición"
                dense
                solo
                @change="cargarEquipos()"
                ></v-select>
            </v-col>
            <v-col>
                <v-select
                :items="equipos"
                item-text="nombre_equipo"
                item-value="id"
                v-model="equipo"
                label="Seleccione Equipo"
                dense
                solo
                @change="obtenerParametros()"
                ></v-select>
            </v-col>
        </v-row>
        -->

        <v-row>
            <v-col v-for="par in parametros" :key="par.id" lg="6" md="6" sm="12" xs="12">
                <v-card
                    color="#3f51b5"
                    dark
                    style="margin:auto;"
                >
                    <v-card-text class="center">
                        <h1 class="el-punto">{{par[0].nombre_punto}}</h1>
                    </v-card-text>
                </v-card>

                <v-card
                    color="#039BE5"
                    dark
                    style="margin:auto;"
                >

                    <v-card-text class="center" >
                        <v-row v-for="p in par" :key="p.id" v-bind:class="[p.valor >= p.alarma01 ? 'filamala' : 'filaok']">
                            <v-col cols="3">
                                <h1 class="fuente-peque">{{p.fecha|diaHora}}</h1>
                            </v-col>
                            <v-col cols="4">
                                <h1 class="fuente-peque">{{p.nombre_equipo}}</h1>
                            </v-col>
                            <v-col cols="3">
                                <span class="fuente-mediana">{{p.nombre_corto}}</span>
                            </v-col>
                            <v-col cols="2">
                                <span class="parpadea fuente-mediana">{{`${redondear(p.valor,1)}`}}</span>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-card class="d-inline-block mx-auto" width="100%" color="grey lighten-3">
            <v-container>
                <v-row>
                    <v-col>
                        <h2>TICKET: {{ultimo_ticket.codigo_ticket}}</h2>
                        <!-- <v-divider color="white"></v-divider> -->
                    </v-col>
                    <v-col>
                        <h2>FECHA INGRESO: {{ultimo_ticket.fecha_hora_ingreso|formatearFecha}}</h2>

                    </v-col>
                    <v-col>
                        <h2>HORA INGRESO: {{ultimo_ticket.fecha_hora_ingreso|formatearHora}}</h2>

                    </v-col>
                    <!-- <v-col>
                        <h2>{{ultimo_ticket.CODIGO_TICKET}}</h2>
                        <v-divider color="white"></v-divider>
                        <h2>{{ultimo_ticket.FECHA_HORA_ACOPLADO|formatearFecha}}</h2>
                        <h2>{{ultimo_ticket.FECHA_HORA_ACOPLADO|formatearHora}}</h2>
                    </v-col> -->
                </v-row>
                <v-row>
                    <v-col>

                    <div class="container-table">
                                <table class="table-dashboard">
                                    <thead>
                                        <th class="cabecera-guias border">N° GUÍA</th>
                                        <th class="cabecera-guias border">PROVEEDOR</th>
                                        <th class="cabecera-guias border">FECHA GUIA</th>
                                        <th class="cabecera-guias border">MATERIA PRIMA</th>
                                        <th class="cabecera-guias border">RESTRICCIÓN</th>
                                    </thead>
                                    <tbody>
                                        <tr class="fuente-tabla-guias"
                                        v-bind:class="[{'parpadea':ultimo_ticket.marcar_rojo != 0,'con_restriccion':ultimo_ticket.marcar_rojo != 0}]">
                                            <td class="border">{{ultimo_ticket.numero_guia}}</td>
                                            <td class="border">{{ultimo_ticket.empresa}}</td>
                                            <td class="border">{{ultimo_ticket.fecha_guia | fechaCompleta}}</td>
                                            <td class="border">{{ultimo_ticket.materia_prima}}</td>
                                            <td class="border">{{ultimo_ticket.restricciones}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                    </v-col>
                    
                </v-row>
            </v-container>
        </v-card>

        <v-row>
            <v-col>
                <v-card>
                <v-card-title color="green darken-1"><div class="title"><h4>ÚLTIMOS TICKETS - GUIAS</h4></div></v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <div class="container-table">
                        <table class="table-dashboard">
                            <thead>
                                <th class="cabecera border">NRO TICKET</th>
                                <th class="cabecera border">NRO GUIA</th>
                                <th class="cabecera border">FECHA RECEPCIÓN ROMANA</th>
                                <th class="cabecera border">MATERIA PRIMA</th>
                                <th class="cabecera border">PROVEEDOR</th>
                                <th class="cabecera border">FECHA GUÍA (ORIGEN)</th>
                                <th class="cabecera border">RESTRICCIÓN</th>
                                <th class="cabecera border">TIEMPO RESTANTE (24hrs)</th>
                                <th class="cabecera border">TIEMPO TRANSCURRIDO (ORIGEN)</th>

                            </thead>
                            <tbody>
                                <tr v-for="i in ticket_guias_2" :key="i.numero_guia" v-bind:class="[{'parpadea':i.marcar_rojo != 0,'con_restriccion':i.marcar_rojo != 0}]">
                                    <td class="border">{{i.codigo_ticket}}</td>
                                    <td class="border">{{i.numero_guia}}</td>
                                    <td class="border">{{i.fecha_hora_ingreso|fechaCompleta}}</td>
                                    <td class="border">{{i.materia_prima}}</td>
                                    <td class="border">{{i.empresa}}</td>
                                    <td class="border">{{i.fecha_guia|fechaCompleta}}</td>
                                    <td class="border">{{i.restricciones}}</td>
                                    <td class="border"><h3>{{i.TIEMPO_RESTANTE}}</h3></td>
                                    <td class="border"><h3>{{i.TIEMPO_TRANSCURRIDO}}</h3></td>
                                </tr>
                                <!-- <tr v-for="i in 3" :key="i">
                                    <td class="border">888956</td>
                                    <td class="border">31/12/2019</td>
                                    <td class="border">23:59</td>
                                    <td class="border">Desecho</td>
                                    <td class="border">Invermar S.A.</td>
                                </tr> -->
                            </tbody>
                        </table>
                    </div>
                </v-card-text>
            </v-card>
            </v-col>
        </v-row>

    </div>
</div>
    
</template>
<script>
import {mapState} from 'vuex';
import Loader_Compartido from '@/components/shared/Loader_Compartido.vue';
export default {
    data:()=>({
        ultimo_ticket:{},
        ultimas_guias:[],
        ultimos_cinco_tickets:[],
        puntos_medicion:[],
        punto:null,
        equipos:[],
        equipo:null,
        parametros:[],
        conf:{
            color:'#039BE5'
        },
        fecha_guia: '',
        fecha_limite:'',
        guia:{
            fecha_guia:'2020-05-07 18:00',
            restante:{
                horas:'',minutos:'',segundos:'',TIEMPO_RESTANTE:''
            }
        },
        tiempo_restante:'',
        guias:[]
    }),
    beforeDestroy() {
        
        this.socket.off('nuevo-ticket',()=>{
            console.log('suscripcion nuevo-ticket terminada');
        });
        this.socket.disconnect();
    },
    mounted(){
        // this.socket.on('nueva_notificacion',(data)=>{
        //     //console.log('nueva-notificacion',data);
        //     this.mifunctioncita(data);
        // })
        this.fecha_guia = this.moment('2020-05-08 13:00');
        this.fecha_limite = this.moment(this.fecha_guia).add(1, 'days');
        // this.tiempo_restante = this.calcularTiempoRestante(this.fecha_limite);
        this.calcularTiempoRestante(this.guia);
        //this.cargarPuntosMedicion();
        this.obtenerParametros();
        this.cargarUltimosTickets();
        // this.socket.connect();
        this.socket.on('nuevo-ticket',(data)=>{
            console.log("informacion recibida del socket",data);
            this.ultimo_ticket = data.ticket;
            this.ultimas_guias = data.guias;
            this.cargarUltimosTickets();
        })
    },
    methods:{
        async consultarPesajes(){
            await this.axios.get(`${this.base_url}pesaje_etruck3`,this.headers).then((res)=>{
                console.log('respuesta etruck 3',res);
            }).catch((error)=>{
                console.log('error',error);
            });
        },
        async cargarPuntosMedicion(){
            this.$emit('iniciar',this.conf);
            // this.mostrarLoading('Cargando Puntos de Medición...')
            let url = `${this.base_url}punto_medicion`
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('puntos de medicion',response.data.data)
                this.puntos_medicion = response.data.data
                this.puntos_medicion.sort(function(a, b){return a.orden - b.orden});
                // this.ocultarLoading()
                // this.obtenerParametros(this.puntos_medicion[0].id)
                this.$emit('terminar');
                
            }).catch((error)=>{
                console.log('error',error)
                // this.ocultarLoading()
                this.$emit('terminar');
            })
        },

        async cargarEquipos(){
            this.$emit('iniciar',this.conf);
            this.equipos = [];
            this.equipo = null;
            let url = `${this.base_url}punto_medicion/equipos/${this.punto}`;
            await this.axios.get(url,this.headers).then((res)=>{
                console.log('equipos',res.data);
                this.equipos = res.data.data;
                this.equipos.sort(function(a, b){return a.orden - b.orden});
                this.$emit('terminar');
            }).catch((error)=>{
                console.log('error',error);
                this.$emit('terminar');
            });
        },

        async obtenerParametros(){
            // this.parametros = [];
            this.$emit('iniciar',this.conf);
            console.log('equipo_id',this.equipo);
            //let url = `${this.base_url}punto_medicion/${this.punto}/equipo/${this.equipo}`;
            let url = `${this.base_url}obtener_resultado_dashboard/1`;
            await this.axios.get(url,this.headers).then((res)=>{
                console.log('resultado_detalles',res.data);
                this.parametros = res.data.data;
                this.$emit('terminar');
            }).catch((error)=>{
                console.log('error',error);
                this.$emit('terminar');
            });
        },

        async cargarUltimosTickets(){
            let url = `${this.base_url}tickets/ultimos`;
            await this.axios.get(url,this.headers).then(async(res)=>{
                console.log('ultimos_tickets',res.data);
                this.ultimos_cinco_tickets = res.data.data;
                this.ultimo_ticket = null;
                await this.ultimos_cinco_tickets.forEach(async ticket => {
                    if (this.ultimo_ticket === null) {
                        this.ultimo_ticket = ticket;
                        //this.ultimas_guias = ticket;
                    }
                    // this.$set(guia,'FECHA_HORA_ACOPLADO',ticket.FECHA_HORA_ACOPLADO);
                    this.$set(ticket,'TIEMPO_TRANSCURRIDO','');
                    this.$set(ticket,'TIEMPO_RESTANTE','');
                    this.guias.push(ticket)
                });
                console.log('ultimas_guias',this.guias);
            }).catch((error)=>{
                console.log('error',error);
            });
        },

        mifunctioncita(data){
            alert(`mensaje 1:${data.mensaje}, mensaje 2: ${data.otro_texto}`);
        },

        calcularTiempoRestante(guia){
            // var deadline = new Date(guia.fecha_guia); 
            // deadline = deadline.getHours() + 24;
            var deadline = this.moment(`${guia.fecha_guia}`).add(1, 'days');
            // deadline = deadline.getTime();
            setInterval(function() { 
            var now = new Date().getTime(); 
            var t = deadline - now; 
            var days = Math.floor(t / (1000 * 60 * 60 * 24)); 
            var hours = Math.floor((t%(1000 * 60 * 60 * 24))/(1000 * 60 * 60)); 
            var minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60)); 
            var seconds = Math.floor((t % (1000 * 60)) / 1000);
            hours = hours < 10? `0${hours}`:hours;
            minutes = minutes < 10? `0${minutes}`:minutes;
            seconds = seconds < 10? `0${seconds}`:seconds;
            // guia.restante.TIEMPO_RESTANTE = `${hours}:${minutes}:${seconds}`;
            guia.TIEMPO_RESTANTE = `${hours}:${minutes}:${seconds}`;
            // guia.restante.horas = hours;
            // guia.restante.minutos = minutes;
            // guia.restante.segundos = seconds;
            // console.log(guia);
            // document.getElementById("demo").innerHTML = days + "d "  
            // + hours + "h " + minutes + "m " + seconds + "s "; 
                // if (t < 0) { 
                //     clearInterval(x); 
                //     document.getElementById("demo").innerHTML = "EXPIRED"; 
                // } 
            
            }, 1000); 
        }
    },
    computed: {
        ticket_guias_2(){
            this.guias.forEach(guia => {
                var limite = this.moment(`${guia.fecha_guia}`).add(1, 'days');
                setInterval(function() { 
                        var now = new Date().getTime(); 
                        /**indica el tiempo restante con respecto a la fecha actual */
                        var t = limite - now; 
                        /**now - limite entrega el tiempo transcurrido desde fecha de expiracion */
                        // var t = now - limite; 

                        var days = Math.floor(t / (1000 * 60 * 60 * 24)); 
                        var hours = Math.floor((t%(1000 * 60 * 60 * 24))/(1000 * 60 * 60)); 
                        var minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60)); 
                        var seconds = Math.floor((t % (1000 * 60)) / 1000);
                        hours = hours < 10? `0${hours}`:hours;
                        minutes = minutes < 10? `0${minutes}`:minutes;
                        seconds = seconds < 10? `0${seconds}`:seconds;
                        // guia.restante.TIEMPO_RESTANTE = `${hours}:${minutes}:${seconds}`;
                        if(t<0){
                            guia.TIEMPO_RESTANTE = `TIEMPO EXPIRADO`;

                            // guia.TIEMPO_RESTANTE = `${days} Días ${hours}:${minutes}:${seconds}`;
                        }else{
                            guia.TIEMPO_RESTANTE = `${hours}:${minutes}:${seconds}`;
                        }
                        
                    }, 1000);

                    /**calcular el tiempo transcurrido desde origen */
                    var origen = this.moment(`${guia.fecha_guia}`);
                    setInterval(function() { 
                        var now = new Date().getTime(); 
                        /**indica el tiempo restante con respecto a la fecha actual */
                        // var t = limite - now; 
                        /**now - limite entrega el tiempo transcurrido desde fecha de expiracion */
                        var t = now - origen; 

                        var days = Math.floor(t / (1000 * 60 * 60 * 24)); 
                        var hours = Math.floor((t%(1000 * 60 * 60 * 24))/(1000 * 60 * 60)); 
                        var minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60)); 
                        var seconds = Math.floor((t % (1000 * 60)) / 1000);
                        hours = hours < 10? `0${hours}`:hours;
                        minutes = minutes < 10? `0${minutes}`:minutes;
                        seconds = seconds < 10? `0${seconds}`:seconds;
                        // guia.restante.TIEMPO_RESTANTE = `${hours}:${minutes}:${seconds}`;
                        if(t<0){
                            guia.TIEMPO_TRANSCURRIDO = `TIEMPO EXPIRADO`;

                            // guia.TIEMPO_RESTANTE = `${days} Días ${hours}:${minutes}:${seconds}`;
                        }else{
                            guia.TIEMPO_TRANSCURRIDO = `${days} Días ${hours}:${minutes}:${seconds}`;
                        }
                        
                    }, 1000);
            });
            return this.guias;
        },
        // ticket_guias(){
        //     let t_g = [];
        //     this.ultimos_cinco_tickets.forEach(t => {
        //         t.guias.forEach(g => {
        //             g.FECHA_HORA_ACOPLADO = t.FECHA_HORA_ACOPLADO;
        //             // g.TIEMPO_RESTANTE = '';
        //             var deadline = this.moment(g.FECHA_GD).add(1, 'days');
        //             setInterval(function() { 
        //                 var now = new Date().getTime(); 
        //                 var t = deadline - now; 
        //                 var days = Math.floor(t / (1000 * 60 * 60 * 24)); 
        //                 var hours = Math.floor((t%(1000 * 60 * 60 * 24))/(1000 * 60 * 60)); 
        //                 var minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60)); 
        //                 var seconds = Math.floor((t % (1000 * 60)) / 1000);
        //                 hours = hours < 10? `0${hours}`:hours;
        //                 minutes = minutes < 10? `0${minutes}`:minutes;
        //                 seconds = seconds < 10? `0${seconds}`:seconds;
        //                 // guia.restante.TIEMPO_RESTANTE = `${hours}:${minutes}:${seconds}`;
        //                 if(t<0){
        //                     g.TIEMPO_RESTANTE = 'TIEMPO EXPIRADO';
        //                 }else{
        //                     g.TIEMPO_RESTANTE = `${hours}:${minutes}:${seconds}`;

        //                 }
        //                 // g.TIEMPO_RESTANTE = t<0?'TIEMPO EXPIRADO':`${hours}:${minutes}:${seconds}`;
        //                 // g.TIEMPO_RESTANTE = `${hours}:${minutes}:${seconds}`;
        //                 // guia.restante.horas = hours;
        //                 // guia.restante.minutos = minutes;
        //                 // guia.restante.segundos = seconds;
        //                 // console.log(t);
        //                 // document.getElementById("demo").innerHTML = days + "d "  
        //                 // + hours + "h " + minutes + "m " + seconds + "s "; 
        //                     // if (t < 0) { 
        //                     //     clearInterval(x); 
        //                     //     document.getElementById("demo").innerHTML = "EXPIRED"; 
        //                     // } 
                        
        //             }, 1000);
        //             t_g.push(g);
        //             console.log('guia',g);
        //         });
        //     });
        //     return t_g;
        // },
        ...mapState(['base_url','headers'])
    },
    components:{
        'loader-compartido':Loader_Compartido
    }
}
</script>
<style>
.title{
    margin: 0 auto;
}
.fuente-grande{
    font-size: 80px;
}
.fuente-mediana{
    font-size: 2.5em;
    font-weight:800;
}
.fuente-peque{
    font-size: 1.5em;
    font-weight:500;
}
.fuente-tabla-guias{
    font-size:18px;
}
.sin_restriccion{
    background-color: #ffff;
    color:#000000;
}
.con_restriccion{
    background-color: #B71C1C;
    color: #ffffff;
}
.center{
    text-align: center;
}
.rojo{
    color: #E53935;
}
.table-dashboard {
  border-collapse: collapse;
  width: 100%;
}

.border{
  border: 1px solid #000;
}

.cabecera{
    padding: 1em;
    background-color: #FFC107;
}

.cabecera-guias{
    padding: 1em;
    background-color: #004D40;
    color:#ffffff;
}

table tbody tr td{
    text-align: center;
    padding: 0.5em;
}

.container-table{
    overflow-x: auto;
}
.cont2{
   margin-left: 20px;
   margin-right: 20px;
}
/*animacion de parpadeo */
.parpadea {
  
  animation-name: parpadeo;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;

  -webkit-animation-name:parpadeo;
  -webkit-animation-duration: 1.5s;
  -webkit-animation-timing-function: linear;
  -webkit-animation-iteration-count: infinite;
}

.filaok{
    background-color: #1e88e5;
    color:white;
}

.filamala{
    background-color: #ffb74d;
    color:white;
}
.el-punto{
    font-size: 1.5em;
    font-weight:500;
    background-color: #3f51b5;
    color:white;
}


@-moz-keyframes parpadeo{  
  0% { opacity: 1.0; }
  25% {opacity: 0.75}
  50% { opacity: 0.50; }
  75% {opacity: 0.75}
  100% { opacity: 1.0; }
}

@-webkit-keyframes parpadeo {  
  0% { opacity: 1.0; }
  25% {opacity: 0.75}
  50% { opacity: 0.50; }
  75% {opacity: 0.75}
  100% { opacity: 1.0; }
}

@keyframes parpadeo {  
  0% { opacity: 1.0; }
  25% {opacity: 0.75}
  50% { opacity: 0.50; }
  75% {opacity: 0.75}
  100% { opacity: 1.0; }
}
/*animacion de parpadeo */

</style>